import { render } from "./rectorStudioManager.vue?vue&type=template&id=5cdbbed6&scoped=true"
import script from "./rectorStudioManager.vue?vue&type=script&lang=js"
export * from "./rectorStudioManager.vue?vue&type=script&lang=js"

import "./rectorStudioManager.vue?vue&type=style&index=0&id=5cdbbed6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cdbbed6"]])

export default __exports__